import { motion } from "framer-motion";
import Reveal from "@/components/site/Reveal";

const BLOCKS = [
  {
    kicker: "El problema",
    body: (
      <>
        Una startup que contrata un software de gestión de personas sin tener definidos sus procesos
        de selección, onboarding o evaluación del desempeño,{" "}
        <span className="font-semibold text-[#06231D]">no va a sacarle partido</span>. Va a pagar una
        suscripción mensual para{" "}
        <span className="font-semibold text-[#06231D]">digitalizar el caos que ya tenía</span>.
      </>
    ),
    tone: "problem",
  },
  {
    kicker: "La base",
    body: (
      <>
        OptimizaRRHH construye <span className="font-semibold text-[#06231D]">la base metodológica</span>{" "}
        que hace que{" "}
        <span className="font-semibold text-[#06231D]">cualquier herramienta de RRHH funcione</span>:
        perfiles de competencias claros, procesos de integración estructurados, sistemas de
        evaluación objetivos y criterios de crecimiento definidos.
      </>
    ),
    tone: "base",
  },
  {
    kicker: "La secuencia",
    body: "El software de RRHH es el siguiente paso. OptimizaRRHH es el paso previo.",
    tone: "sequence",
  },
];

export default function Positioning() {
  return (
    <section
      id="por-que-antes"
      data-testid="positioning-section"
      className="relative bg-[#F7F9F8] text-[#06231D] py-28 lg:py-40 grain scroll-mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 lg:items-start mb-16 lg:mb-24">
          <Reveal className="lg:col-span-4 lg:self-start">
            <div className="flex items-center gap-4">
              <span className="font-serif-italic text-[#085041] text-[9rem] lg:text-[12rem] leading-none -mt-5 lg:-mt-8 block">
                02
              </span>
              <span className="inline-block text-xs lg:text-sm uppercase tracking-[0.18em] font-medium text-[#F7F9F8] bg-[#06231D] px-3 py-2 rounded-md">
                El paso previo
              </span>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <Reveal>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] max-w-[26ch]">
                ¿Por qué OptimizaRRHH{" "}
                <span className="font-serif-italic text-[#085041] font-normal">antes</span> que un software de RRHH?
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          {BLOCKS.map((b, i) => {
            const isSequence = b.tone === "sequence";
            return (
              <motion.article
                key={b.kicker}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className={
                  isSequence
                    ? "relative lg:col-span-12 rounded-3xl bg-[#06231D] text-white p-10 lg:p-14 overflow-hidden"
                    : "relative lg:col-span-6 rounded-3xl bg-[linear-gradient(160deg,#EFF8F3,#E1F2E9)] border border-[#2EC48A]/25 p-8 lg:p-10"
                }
                data-testid={`positioning-block-${i}`}
              >
                {isSequence && (
                  <>
                    <div className="absolute top-0 left-0 h-px w-40 brand-gradient" />
                    <div className="absolute bottom-0 right-0 h-px w-40 brand-gradient" />
                    <div
                      aria-hidden
                      className="absolute -bottom-32 -right-24 w-[520px] h-[520px] rounded-full blur-[140px] opacity-25"
                      style={{ background: "radial-gradient(circle,#C9A84C 0%, transparent 70%)" }}
                    />
                  </>
                )}

                <div className={`flex items-center gap-3 mb-6 text-[11px] uppercase tracking-[0.24em] ${isSequence ? "text-[#C9A84C]" : "text-[#085041] font-bold"}`}>
                  <span className={`w-6 h-px ${isSequence ? "bg-[#C9A84C]" : "bg-[#085041]"}`} />
                  {b.kicker}
                </div>

                <p
                  className={
                    isSequence
                      ? "relative font-display text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.15] tracking-tight max-w-[28ch] text-justify hyphens-auto"
                      : "text-[#06231D]/80 text-lg leading-relaxed font-light text-justify hyphens-auto"
                  }
                >
                  {isSequence ? (
                    <>
                      <span className="block">
                        El <span className="text-white/80">software de RRHH</span> es el{" "}
                        <span className="font-serif-italic font-normal text-[#C9A84C]">siguiente</span> paso.
                      </span>
                      <span className="block mt-5 lg:mt-7">
                        OptimizaRRHH es el{" "}
                        <span className="font-serif-italic font-normal text-[#2EC48A]">paso previo</span>.
                      </span>
                    </>
                  ) : (
                    b.body
                  )}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
